import { FilterList } from "@mui/icons-material";
import {
  Autocomplete,
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";

import React, { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CustomerCompanyFilter({
  sortingField,
  sortingOrder,
  setSortingField,
  setFilter,
  setSortingOrder,
  includeDeleted,
  setIncludeDeleted,
  plateList,
  setPlateId,
  plate_id,
  show,
}) {
  const resetFilters = () => {
    setSortingField("");
    setSortingOrder("");
    setIncludeDeleted(false);
    setPlateId(null);
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  const [count, setCount] = useState(0);
  useEffect(() => {
    let totalCount = 0;

    if (sortingField) {
      totalCount++;
    }
    if (sortingOrder) {
      totalCount++;
    }

    if (includeDeleted) {
      totalCount++;
    }

    if (plate_id) {
      totalCount++;
    }
    setCount(totalCount);
  }, [sortingField, sortingOrder, includeDeleted]);
  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Field</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Field"
                      onChange={(e) => setSortingField(e.target.value)}
                      value={sortingField}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Field
                      </MenuItem>
                      <MenuItem value="name">Name</MenuItem>
                      <MenuItem value="created_at">Created At</MenuItem>
                      <MenuItem value="updated_at">Updated At</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Order</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Order"
                      onChange={(e) => setSortingOrder(e.target.value)}
                      value={sortingOrder}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Order
                      </MenuItem>
                      <MenuItem value="asc">Ascending</MenuItem>
                      <MenuItem value="desc">Descending</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {show && <Grid item xs={12} md={12} lg={12}>
                  <Autocomplete
                    id="plate_id"
                    options={plateList}
                    value={plate_id}
                    onChange={(e, value) => {
                      setPlateId(value);
                    }}
                    getOptionLabel={(option) =>
                      option ? `${option.height}x${option.width}x${option.thickness}` : ""
                    }
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Plate"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>}
                <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={includeDeleted}
                          onChange={(e) => setIncludeDeleted(e.target.checked)}
                        />
                      }
                      label="Show deleted companies"
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleClose} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default CustomerCompanyFilter;
